import React, { FC, useMemo } from 'react'
import { remark } from 'remark'
import strip from 'strip-markdown'

import { useMeta, useTitle, useScript } from 'hoofd'

import { DEFAULT_BACKGROUND } from '@data/config/images'

const IMAGEKIT_PARAMS = {
  DEFAULT: {
    'og:image': '?tr=w-1200',
    // 'twitter:image': '?tr=w-1200,ar-2-1,fo-auto',
    'twitter:image': '?tr=w-1200,h-600',
  },
  FULL_SIZE: {
    'og:image': '?tr=w-1200',
    // 'twitter:image': '?tr=w-1200,h-600,cm-pad_resize,bg-000000',
    'twitter:image': '?tr=w-1200,h-600',
  },
  NONE: {
    'og:image': '',
    'twitter:image': '',
  },
} as const

const websiteStructuredData = JSON.stringify({
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Guild',
  url: 'https://guild.host/',
})

export const Metadata: FC<{
  description?: string | null
  imageKitParams?: keyof typeof IMAGEKIT_PARAMS
  photoUrl?: string | null
  title: string
}> = ({ description, imageKitParams = 'DEFAULT', photoUrl, title }) => {
  const imageURL = useMemo(() => {
    return photoUrl ?? DEFAULT_BACKGROUND
  }, [photoUrl])

  const contentDescription = useMemo(() => {
    if (!description) {
      return
    }

    return String(remark().use(strip).processSync(description))
  }, [description])

  useTitle(`${title} | Guild`)
  useMeta({ property: 'og:title', content: `${title} | Guild` })

  useMeta({ property: 'og:site_name', content: 'Guild' })

  useScript({
    type: 'application/ld+json',
    text: websiteStructuredData,
  })

  useMeta({
    property: 'og:image',
    content: `${imageURL}${IMAGEKIT_PARAMS[imageKitParams]['og:image']}`,
  })

  useMeta({ property: 'twitter:title', content: title })
  useMeta({ property: 'twitter:card', content: 'summary_large_image' })
  useMeta({
    property: 'twitter:image',
    content: `${imageURL}${IMAGEKIT_PARAMS[imageKitParams]['twitter:image']}`,
  })

  if (contentDescription) {
    return <MetadataDescription description={contentDescription} />
  }

  return null

  // return (
  //   <Helmet defer={false} prioritizeSeoTags>
  //     <title>{title} | Guild</title>
  //     {/* <meta property='og:type' content='og:website' /> */}
  //     <meta property='og:title' content={title} />
  //     {!!contentDescription && [
  //       <meta
  //         key='description'
  //         property='description'
  //         content={contentDescription}
  //       />,
  //       <meta
  //         key='og:description'
  //         property='og:description'
  //         content={contentDescription.substring(0, 140)}
  //       />,
  //     ]}
  //     {/* <meta property='twitter:card' content='summary_large_image' /> */}
  //     {Object.entries(IMAGEKIT_PARAMS[imageKitParams]).map(([key, value]) => (
  //       <meta key={key} property={key} content={url + value} />
  //     ))}
  //   </Helmet>
  // )
}

const MetadataDescription: FC<{ description: string }> = ({ description }) => {
  useMeta({ property: 'description', content: description })
  useMeta({
    property: 'og:description',
    content: description.substring(0, 140),
  })
  useMeta({ property: 'twitter:description', content: description })

  return null
}
